import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ResidentialService } from '../../questionarie-signup/questionnaire-residential/residential.service';
import * as $ from 'jquery';
import { Router, NavigationEnd } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { Title, Meta } from '@angular/platform-browser';
import {
  CloudinaryModule,
  CloudinaryConfiguration,
} from '@cloudinary/angular-5.x';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
})
export class AboutComponent implements OnInit, AfterViewInit {
  videoSrc;
  showHelp = false;
  previousUrl;

  constructor(
    private residentialService: ResidentialService,
    private route: Router,
    private title: Title,
    private meta: Meta
  ) {}
  ngOnInit() {
    this.title.setTitle(
      'Honest Gorilla | Shop for Energy | Save with Confidence'
    );
    this.meta.updateTag({
      name: 'keywords',
      content:
        'residential energy,shop for electricity for my home,need electricity asap,home energy,apartment,switch providers,new service,smart home,how do I save money on electricity bills,how do I save energy,I am moving and need to find a new electricity provider,movers,real estate agent,buying a home,renting a home,renting an apartment,Zillow,redfin,keller Williams,remax,c21,rogershealy,compass,Coldwell banker,apartment finders,smartcity apartment locating,Houston,Dallas,Richardson,Mesquite,Irving,Arlington,Amli,Lincoln Property Company,leasing an apartment,honest recommendation,lowest electricity price,cheapest electricity price,TXU,Reliant,Green Mountain,compare power companies,light companies,power to choose,save on energy,Texas electricity rates,Texas electricity prices,electric choice,energy deregulation,dereg101,cheap electricity deal,choose my electric company,Griddy,Frontier Utilities,Ambit Energy,Stream Energy,free nights and weekends,google home,energy plans,new home,new apartment,electric choice',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'Honest Gorilla is a smarter way to shop for energy. Compare prices and find products that cater to your budget, lifestyle and household or business. Get started today!',
    });
    this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });

    if (window.location.href.includes('promo')) {
      const url = window.location.href;
      if (url.includes('?')) {
        const httpParams = url.split('?')[1];
        //if(httpParams.split('=')[1] === "TAP")
        sessionStorage.setItem('Promocode', httpParams.split('=')[1]);
      }
    }
  }
  closebootvideo() {
    $('#myModal iframe').attr('src', jQuery('#myModal iframe').attr('src'));
  }
  closeHelpModal() {
    $('#myModal iframe').attr('src', jQuery('#myModal iframe').attr('src'));
  }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
    this.route.events
      .pipe(
        filter((e: any) => e instanceof NavigationEnd),
        pairwise()
      )
      .subscribe((e: any) => {
        // // console.log.log('prev:', e);
        this.previousUrl = e[0].url;
        // // console.log.log('PreviousUrl:' + this.previousUrl);
        if (this.route.url === '/about') {
          if (this.previousUrl && this.previousUrl !== '/about') {
            $('.aboutshop')[0].click();
          }
        }
      });
  }

  help() {
    this.showHelp = true;
    this.residentialService.setHelpFlag({ flag: true });
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
  }

  checkoutRates() {
    const scrollInitial = document.getElementsByTagName('html');
    scrollInitial[0].classList.add('letsgo');
    this.route.navigateByUrl('/get-started');
  }

  clickShopNow() {
    this.residentialService.currentId = '000';
    this.residentialService.nextId = '001';
    this.residentialService.selectedType = '';
    this.residentialService.questionnaireStatusObj = {
      percentage: '0',
      questionStatus: '',
      questionStep: '',
      type: '',
    };
    this.residentialService.messageService({});
    this.residentialService.userResponse.userResponses = [];
    this.residentialService.isStartOver = true;
    sessionStorage.removeItem('questionStatusObj');
    sessionStorage.removeItem('userResponse');
    sessionStorage.removeItem('percentage');
    sessionStorage.clear();
    this.residentialService.messageService({
      currentId: null,
      questionStatus: null,
    });
    this.route.navigateByUrl('/residentialQues');
  }
}
